<template>
  <div class="users-layout">
    <default-box
      :loader="loading">
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div>
          <search-input
              :placeholder="$t('inputs.search')"
              :value="search"
              @change="searchFetchList"
          />
        </div>
        <router-link-to
          default_button
          :route_name="route_names.user"
          :route_params="{id: 0}">
          {{ $t('user.new_user') }}
        </router-link-to>
      </div>
      <tables-slot
        :empty_spacer="loading"
        @paginationFetch="fillData"
        @popstateEvent="fetchList"
        :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('user.name') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.surname') }}</td>
          <td class="w-0 text-nowrap" v-if="getUserRoleIsAdmin">{{ $t('user.active') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.role') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.committee') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.available_vacation_days') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.impersonate') }}</td>
          <td class="w-0 text-nowrap">{{ $t('user.edit') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="item in list">
            <td class="w-0 text-nowrap">
              {{ item.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.name }}
            </td>
            <td class="w-0 text-nowrap">
              {{ item.surname }}
            </td>
            <td
              v-if="getUserRoleIsAdmin"
              class="w-0 text-nowrap">
              <switcher
                placeholder="Active"
                :checked="!!item.active"
                @change="changeActive(item)"
              />
            </td>
            <td class="w-0 text-nowrap">
              {{ item.role?.name ?? 'No role' }}
            </td>
            <td class="w-0 text-nowrap">
              <p v-if="item.manager_committees.length" class="fw-bold mb-1">
                <span>{{item.manager_committees.map(e => e.title).join(', ')}}</span>
                - manager
              </p>
              <p v-if="item.committee_employee" class="fw-bold mb-10">
                {{item.committee_employee.title}} - employee
              </p>
            </td>
            <td class="w-0 text-nowrap">
              <div
                v-if="edit_vacations_qty_id !== item.id"
                class="d-flex align-items-center">
                <span>{{item.available_vacation_days}}</span>
                <span
                  class="ml-10">
                </span>
              </div>
              <div v-else
                   class="d-flex align-items-center">
                <default-input
                  class="mw-50"
                  type="number"
                  v-model="item.available_vacation_days"
                />
                <default-button
                  class="ml-10"
                  button_small
                  @click="saveEditDays(item)">
                  ✓
                </default-button>
                <span
                  class="ml-10"
                  @click="closeEditDays(item)">
                  <close-icon :size="20"/>
                </span>
              </div>
            </td>
            <td class="w-0 text-nowrap">
              <default-button
                v-if="item.id !== getUser.id"
                button_small
                @click="impersonate(item)">
                <logout-icon/>
              </default-button>
            </td>
            <td class="w-0 text-nowrap">
              <span
                  @click="deleteItem(item.id)"
                  class="d-inline-block px-10 py-10 cursor_pointer">
                <trash-icon/>
              </span>
              <router-link-to
                  class="d-inline-block px-10 py-10"
                  :route_params="{id: item.id}"
                  :route_name="route_names.user_equipment">
                <equipment-icon/>
              </router-link-to>
              <router-link-to
                class="d-inline-block px-10 py-10"
                :route_params="{id: item.id}"
                :route_name="route_names.user">
                <edit-icon/>
              </router-link-to>

            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
  </div>
</template>

<script>

import calendar_mixin from "../../../mixins/calendar_mixin";
import {axiosArticles, axiosUsers} from "../../../helpers/axios_requests";
import {GET_QUERY_OBJECT_VALUE, REPLACE_IN_QUERY, REPLACE_STATE} from "../../../helpers/url_helper";
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import TablesSlot from "../../small_components/tables/TablesSlot.vue";
import Switcher from "../../small_components/Switcher.vue";
import EditIcon from "../../icons/EditIcon.vue";
import EquipmentIcon from "../../icons/EquipmentIcon.vue";
import {mapActions, mapGetters} from "vuex";
import DefaultBox from "../../slots/DefaultBox.vue";
import SearchInput from "../../small_components/SearchInput.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import CloseIcon from "../../icons/CloseIcon.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import LogoutIcon from "../../icons/LogoutIcon.vue";
import {GO_TO_DASHBOARD} from "../../../router";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";
import TrashIcon from "../../icons/TrashIcon.vue";

export default {
  name: 'UsersLayout',
  mixins: [calendar_mixin, routes_mixin],
  components: {
    TrashIcon,
    LogoutIcon,
    DefaultButton,
    CloseIcon,
    DefaultInput,
    SearchInput,
    DefaultBox,
    EditIcon,
    EquipmentIcon,
    Switcher,
    TablesSlot,
    RouterLinkTo,
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getUserRoleIsAdmin'
    ])
  },
  beforeMount() {
    this.fetchList()
    this.search = GET_QUERY_OBJECT_VALUE('search', location.search)
  },
  data() {
    return {
      list: [],
      pagination: [],
      loading: false,
      search: '',
      edit_vacations_qty_id: 0,
      old_user_qty_days: 0
    }
  },
  methods: {
    ...mapActions([
      'actionSetUser',
      'actionSetAdminImpersonateUser',
      'actionPushNotification',
      'actionPushNotificationMessage',
    ]),
    searchFetchList(e) {
      this.search = e.target.value
      REPLACE_STATE(
        REPLACE_IN_QUERY(location.search, 'search', this.search)
      )
      this.fetchList()
    },
    fetchList() {
      this.loading = true

      axiosUsers.list({
        search: this.search,
      })
        .then(r => this.fillData(r.data))
        .finally(() => {
          this.loading = false
        })
    },
    fillData({collection, pagination}) {
      this.list = collection || []
      this.pagination = pagination || []
    },
    changeActive(item) {
      item.active = item.active ? 0 : 1
      axiosUsers.updateActive({
        id: item.id,
        active: item.active
      }).then(r => {
        if (r.data.errors) {
          let message = FORMAT_ERROR_MESSAGE(r.data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
        }
      })
    },
    changeEditDays(item) {
      this.edit_vacations_qty_id = item.id
      this.old_user_qty_days = item.available_vacation_days
    },
    closeEditDays(item) {
      item.available_vacation_days = this.old_user_qty_days
      this.edit_vacations_qty_id = 0
      this.old_user_qty_days = 0
    },
    saveEditDays(item) {
      axiosUsers.createUpdateAvailableVacationDays({
        user_id: item.id,
        days_qty: item.available_vacation_days,
      }).then(r => {
        if (r.data.errors) {
          let message = FORMAT_ERROR_MESSAGE(r.data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.edit_vacations_qty_id = 0
        this.old_user_qty_days = 0
        this.actionPushNotificationMessage('Saved')
      })
      if (item.id !== this.getUser.id) return
      this.getUser.available_vacation_days = item.available_vacation_days
    },
    impersonate(item) {
      axiosUsers.login_by_id({
        id: item.id,
      }).then(({data}) => {
        this.actionSetAdminImpersonateUser(this.getUser || null)
        this.actionSetUser(data.user || null)
        GO_TO_DASHBOARD()
      })
    },
    deleteItem(id) {
      this.loading = true
      axiosUsers.delete(id)
          .then(r => this.fetchList())
          .finally(() => {
            this.loading = false
          })
    },
  }
}
</script>
